/*
 * Returns an new object without mutating it.
 * @param {Object} the current Object
 * @param {Object} the changes to the Object
 * @return {Object} a new object with changes assigned
 */
const update = (obj, mutations) => ({ ...obj, ...mutations });

/*
 * Returns an new object without mutating it.
 * @param {Array} the list of Objects
 * @param {Number} the index you want to update.
 * @param {Object} the changes to the Object
 * @return {Array} a new list with the with changes assigned
 */
const func = (list, index, mutations) => [
  ...list.slice(0, index),
  update(list[index], mutations),
  ...list.slice(index + 1),
];
export default func;
